import { Button } from '@mui/material';

interface StandardButtonProps {
    onClick: () => void;
    text: string;
    color?: 'primary' | 'error';
}

export const StandardButton = ({ onClick, text, color }: StandardButtonProps) => {
    return (
        <Button
            variant={'contained'}
            color={color || 'primary'}
            style={{ marginLeft: '20px', height: '30px', fontSize: '12.5px' }}
            onClick={onClick}>
            {text}
        </Button>
    );
};
